import { Passenger, PassengerNameFormData } from './index.types';

export const appendAdditionalFields = (passengers: Passenger[]) =>
    passengers.map((passenger) => ({
        ...passenger,
        updatedTitle: passenger.title,
        updatedFirstName: passenger.firstName,
        updatedLastName: passenger.lastName,
    }));

export const isPassengerNameModified = (traveller: PassengerNameFormData) =>
    traveller.title !== traveller.updatedTitle ||
    traveller.firstName !== traveller.updatedFirstName ||
    traveller.lastName !== traveller.updatedLastName;
